<div class="row input-font-style {{classes}}" [style.height]="height" [style.paddingTop]="paddingTop" [style.paddingBottom]="paddingBottom">
  <ng-content></ng-content>
</div>